module.exports = __webpack_public_path__ + "static/media/livetrue.f37d9931.jpg";